export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70df4956e3144371168c229df988f4fc6055c38b45&name=pushAdClickData!'